module.exports = function() {
  return new Worker(__webpack_public_path__ + "9438624a921118f473b8.worker.js");
};